import { render, staticRenderFns } from "./priceChangeManage.vue?vue&type=template&id=166e1d52&scoped=true"
import script from "./priceChangeManage.vue?vue&type=script&lang=js"
export * from "./priceChangeManage.vue?vue&type=script&lang=js"
import style0 from "./priceChangeManage.vue?vue&type=style&index=0&id=166e1d52&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "166e1d52",
  null
  
)

export default component.exports